<template>
    <div v-if="canSeePrices && hasCustomers && custAll.length" id="orgswitcher">
        <div v-if="custAll.length > 1 || (custAll.length === 1 && userLevel <= 2)" class="dropdown" id="switch-orgs">
            <em>
                {{labels[orgSwitcherLabelId]}}<!-- label: Pricing:  -->
                <a id="change-org" class="dropdown-toggle" data-toggle="dropdown" data-target="#switch-orgs" :title="primaryCust.name">
                    {{truncate(primaryCust.name, 30)}}<i class="caret"></i>
                </a>
            </em>
            <ul class="dropdown-menu">
                <li v-if="userLevel <= 2 && primaryCust.iid != -1">
                    <a href="" rel="-1">CSI Employee Selected</a>
                </li>
                <template v-for="c in custAll">
                    <li v-if="c.iid != primaryCust.iid" :key="c.iid">
                        <a href="" :rel="c.iid">{{c.name}}</a>
                    </li>
                </template>
            </ul>
        </div>
        <div v-else>
            {{custAll[0].name}}
        </div>
    </div>
</template>

<script>
import useCart from "../composables/useCart"
import useCMS from "../../shared/composables/useCMS"
import useUtils from "../../shared/composables/useUtils"

export default {
    name: 'OrgSwitcher',
    props: {
        orgSwitcherLabelId: Number
    },
    setup () {
        const {custAll, primaryCust, canSeePrices, hasCustomers, userLevel} = useCart();
        const { labels } = useCMS();
        const { truncate } = useUtils();

        return {
            custAll,
            primaryCust,
            canSeePrices,
            hasCustomers,
            userLevel,
            truncate,
            labels
        }
    }
}
</script>
